var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',{staticClass:"reg-text"},[_vm._v("\n        Консультацію можна отримати за телефоном гарячої лінії клінічного харчування 0 800 50 17 85 (09:00-19:00, дзвінки зі стаціонарних телефонів по Україні безкоштовні)\n    ")])])
}]

export { render, staticRenderFns }